import React from 'react';
import { observer } from 'mobx-react';
import { GroupStore, RouteStore } from '@seedlang/stores';
import { AppUI } from '@seedlang/state';
import CreateWithTitle from 'components/creator/create_with_title';

@observer
class GroupCreate extends React.Component {

  onCreate = name => {
    GroupStore.create({data: {name, siteId: AppUI.siteId}}, this.afterCreate);
  };

  afterCreate = resp => {
    RouteStore.routeToNamed('builder.groups.edit', {groupId: resp.id});
  };

  render() {
    return (
      <CreateWithTitle
        placeholder='Enter a name'
        onCreate={this.onCreate}
      />
    );
  }
}

export default GroupCreate;
